(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        // window.productV1 = product;
        // window.activeVariant = activeVariant;
    }
    /************
     Swiper
     *************/
    document.addEventListener('DOMContentLoaded', function () {
        new Swiper(section.querySelector('.productV1VisualMobile'), {
            slidesPerView: 1,
            spaceBetween: 28,
            loop: true,
            navigation: {
                nextEl: section.querySelector('.productV1VisualMobileControl.next'),
                prevEl: section.querySelector('.productV1VisualMobileControl.prev'),
            }
        });
    });

    /************
     Required Variables
     *************/

    const requiredProductsCount = JSON.parse(section.dataset.reqired)

    // Products to add
    let productsToAdd = [];
    let productsToAddCount = 0;

    /*************
     Reviews
     **********/

    section.querySelectorAll(`.productV1Reviews[href="#okendo"]`).forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const okendoSection = document.querySelector("[data-oke-widget]");
            if (okendoSection) {
                window.scrollTo({
                    top: okendoSection.offsetTop,
                    behavior: "smooth",
                });
            }
        })
    })

    /**************
     Update Product
     ***************/

    async function updateProduct() {
        // reset products to add
        productsToAdd = [];

        // find all products to add
        section.querySelectorAll('.productV1ProductsItem').forEach((element) => {
            // update quantity display
            let quantity = parseInt(element.dataset.quantity);
            element.querySelector('.productV1ProductsItemBodyControlsQtyValue').textContent = quantity;
        console.log('dataset.quantity:', element.dataset.quantity);
        console.log('parsed quantity:', quantity);

            // if quantity is more than 0
            if (quantity > 0) {
                // add to products to add
                console.log('STEP 1 - inside quantity > 0');
                let product = JSON.parse(element.dataset.product);
                console.log('STEP 2 - product parsed');
                //try to find the 2 month plan
                    let selling_plan_id = null;

                    if (
                        product.selling_plan_groups &&
                        product.selling_plan_groups.length > 0 &&
                        product.variants &&
                        product.variants.length > 0 &&
                        product.variants[0].selling_plan_allocations &&
                        product.variants[0].selling_plan_allocations.length > 0
                    ) {

                        let sellingGroup = product.selling_plan_groups[0].id;

                        for (let group of product.selling_plan_groups) {
                            if (group.name.includes("2 months")) {
                                sellingGroup = group.id;
                            }
                        }

                        selling_plan_id = product.variants[0].selling_plan_allocations[0].selling_plan_id;

                        for (let allocation of product.variants[0].selling_plan_allocations) {
                            if (allocation.selling_plan_group_id === sellingGroup) {
                                selling_plan_id = allocation.selling_plan_id;
                            }
                        }
                    }

     console.log('STEP 6 - before push');
                productsToAdd.push({
                    id: product.variants[0].id,
                    price: parseInt(element.dataset.price),
                    comparePrice: parseInt(element.dataset.compare),
                    selling_plan: {
                        id: selling_plan_id,
                        price: parseInt(element.dataset.subPrice),
                        comparePrice: parseInt(element.dataset.compare),
                    },
                    quantity: quantity
                });
     console.log('STEP 7 - pushed');
                // update visuals
                element.querySelector('.productV1ProductsItemBodyAdd').classList.remove('active');
                element.querySelector('.productV1ProductsItemBodyControls').classList.add('active');
            } else {
                // update visuals
                element.querySelector('.productV1ProductsItemBodyAdd').classList.add('active');
                element.querySelector('.productV1ProductsItemBodyControls').classList.remove('active');
            }
        });
     console.log('productsToAdd before reduce:', productsToAdd);

        // count products to add
        productsToAddCount = productsToAdd.reduce((acc, item) => acc + item.quantity, 0);
        console.log('productsToAddCount', productsToAddCount)
        // determine products remaining
        let productsRemaining = requiredProductsCount - productsToAddCount;

        // prices
        let totalPrice = 0;
        let totalCompare = 0;
        let totalSubscriptionPrice = 0;
        let totalSubscriptionCompare = 0;

        productsToAdd.forEach((item) => {
            totalPrice += item.price * item.quantity;
            totalCompare += item.comparePrice * item.quantity;
            totalSubscriptionPrice += item.selling_plan.price * item.quantity;
            totalSubscriptionCompare += item.selling_plan.comparePrice * item.quantity;
        });

        // prices with included products
        // included products might not always exist, so we need to check for them
        let totalPriceWithIncludedOTP = totalPrice;
        let totalCompareWithIncludedOTP = totalCompare;
        if (otp_bundle) {
            totalPriceWithIncludedOTP += otp_bundle_price;
            if (otp_bundle.variants[0].compare_at_price > otp_bundle.variants[0].price) {
                totalCompareWithIncludedOTP += otp_bundle.variants[0].compare_at_price;
            } else {
                totalCompareWithIncludedOTP += otp_bundle.variants[0].price;
            }
        }
        let discountedTotalPriceWithIncludedOT = totalPriceWithIncludedOTP - 802.00;
        let totalPriceWithIncludedSub = totalSubscriptionPrice;
        let totalCompareWithIncludedSub = totalSubscriptionCompare;
        if (sub_bundle) {
            totalPriceWithIncludedSub += sub_bundle_price;
            if (sub_bundle.variants[0].compare_at_price > sub_bundle.variants[0].price) {
                totalCompareWithIncludedSub += sub_bundle.variants[0].compare_at_price;
            } else {
                totalCompareWithIncludedSub += sub_bundle.variants[0].price;
            }
        }
        let discountedTotalPriceWithIncludedSub = totalPriceWithIncludedSub - 2000;


        // update first delivery price
        section.querySelectorAll(".productV1ReceiptItemPriceReal")[0].textContent = price(discountedTotalPriceWithIncludedSub);
        section.querySelectorAll(".productV1ReceiptItemPriceCompare")[0].textContent = "$232.00";
        if (totalCompareWithIncludedSub > totalPriceWithIncludedSub) {
            section.querySelectorAll(".productV1ReceiptItemPriceCompare")[0].textContent = price(totalCompareWithIncludedSub);
        }

        // update recurring (detergent only) price
        section.querySelectorAll(".productV1ReceiptItemPriceReal")[1].textContent = price(totalSubscriptionPrice);
        section.querySelectorAll(".productV1ReceiptItemPriceCompare")[1].textContent = "";
        if (totalSubscriptionCompare > totalSubscriptionPrice) {
            section.querySelectorAll(".productV1ReceiptItemPriceCompare")[1].textContent = price(totalSubscriptionCompare);
        }

        // update OTP prices
        section.querySelector(".productV1PriceReal").textContent = price(discountedTotalPriceWithIncludedOT);
        section.querySelector(".productV1PriceCompare").textContent = "";
        if (totalCompareWithIncludedOTP > totalPriceWithIncludedOTP) {
            section.querySelector(".productV1PriceCompare").textContent = price(totalCompareWithIncludedOTP);
        }


        // Update ATC buttons
        if (productsRemaining > 0) {
            section.querySelectorAll('.productV1ATC').forEach((element) => {
                element.classList.add('disabled');
            })
            section.querySelector('.productV1Required').textContent = ` Add 2 Detergents · 100+ Loads `;
            section.querySelector('.productV1ATC.sub').textContent = `Add ${productsRemaining} More Detergents`;
        } else {
            section.querySelectorAll('.productV1ATC').forEach((element) => {
                element.classList.remove('disabled');
            })
            section.querySelector('.productV1Required').textContent = `Claim your offer!`;
            section.querySelector('.productV1ATC.sub').textContent = `Claim now – Free Gift Applied`;
        }

        // scroll to ATC btns if we're at the correct amount
        if (productsRemaining === 0) {
            // scroll so it's 100px from bottom of page
            window.scrollTo({
                top: section.querySelector('.productV1ATC.once').offsetTop - window.innerHeight + 100,
                behavior: "smooth",
            });
        }
    }


    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();


    /**************
     Product Quantities
     ***************/

    section.querySelectorAll(".productV1ProductsItem").forEach(function (element) {
        // plus
        element.querySelectorAll(".plus").forEach(function (button) {
            button.addEventListener("click", function () {
                let quantity = parseInt(element.dataset.quantity);
    
                // if we're at the max product cap, show an error
                if (productsToAddCount === requiredProductsCount) {
                    Swal.fire({
                        html: `You have ${requiredProductsCount} detergents selected.<br> Please remove 1 to add another.`,
                        timer: 3000,
                        customClass: {
                            container: 'error'
                        },
                        showConfirmButton: false
                    });
                    return;
                }

                // increment quantity
                quantity++;
                element.dataset.quantity = quantity;

                // refresh product
                updateProduct();
            });
        });

        // minus
        element.querySelectorAll(".minus").forEach(function (button) {
            button.addEventListener("click", function () {
                let quantity = parseInt(element.dataset.quantity);

                // decrement quantity
                if (quantity > 0) {
                    quantity--;
                    element.dataset.quantity = quantity;
                    updateProduct();
                }
            });
        });

        // initial  add
        element.querySelectorAll('.productV1ProductsItemBodyAdd').forEach((button) => {
            button.addEventListener('click', () => {
                 console.log('test', productsToAddCount, requiredProductsCount);
                if (productsToAddCount === requiredProductsCount) {
                    Swal.fire({
                        html: `You have ${requiredProductsCount} detergents selected.<br> Please remove 1 to add another.`,
                        timer: 3000,
                        customClass: {
                            container: 'error'
                        },
                        showConfirmButton: false
                    });
                    return;
                }

                // update quantity
                button.closest('.productV1ProductsItem').dataset.quantity = 1;

                // update products
                updateProduct();
            })
        })

        // remove
        element.querySelectorAll('.productV1ProductsItemBodyControlsRemove').forEach((button) => {
            button.addEventListener('click', () => {

                // update quantity
                button.closest('.productV1ProductsItem').dataset.quantity = 0;

                // update products
                updateProduct();
            })
        })

    });

    /**************
     Product ATC
     ***************/

    section.querySelectorAll('.productV1ATC').forEach((element) => {
        element.addEventListener('click', async function () {

            if (element.classList.contains('disabled')) {
                Swal.fire({
                    text: `Please Choose ${requiredProductsCount} detergents to Continue.`,
                    // timer: 3000,
                    customClass: {
                        container: 'error'
                    },
                    showConfirmButton: false
                });

                return;
            }

            // add loading animation to both buttons
            section.querySelector(".productV1ATC").classList.add("loading");

            let formData = {
                items: []
            };

            // add selected products
            productsToAdd.forEach(item => {
                let selling_plan = null;
                if (element.classList.contains('sub')) {
                    selling_plan = item.selling_plan.id;
                }

                formData.items.push({
                    quantity: item.quantity,
                    id: item.id,
                    selling_plan: selling_plan
                });
            });

            // add included products
            if (element.classList.contains('sub') && sub_bundle) {
                formData.items.push({
                    quantity: 1,
                    id: sub_bundle.variants[0].id
                })
            } else if (otp_bundle) {
                formData.items.push({
                    quantity: 1,
                    id: otp_bundle.variants[0].id
                })
            }

            // clear cart
            await fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            // add product
            await addProduct(formData);

            // remove loading animation
            section.querySelector(".productV1ATC").classList.remove("loading");

            // checkout
            window.location.href = "/checkout";
        });
    });


    // setup Dropdowns
    section.querySelectorAll(".productV1IncludedBodyItemTop").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

}());